import Vue from "vue";
import Router from "vue-router";
import Landing from "@/views/Landing.vue";
import MainNavbar from "@/layout/MainNavbar.vue";
import MainFooter from "@/layout/MainFooter.vue";
import Not_found from '@/views/NotFound.vue';
import Top_consumers from '@/views/Top_consumers.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(Router);
Vue.use(VueAxios, axios);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  
  routes: [

    {
      path: "",
      name: 'Top_consumers',
      component: Top_consumers,
    },
    
    {
      path: "/:id",
      name: 'Landing',
      components: { default:Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    
    {
      path: '*',
      name: 'Not_found',
      component: Not_found
      }
  ],

  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
